const remoteConfig = () => ({
  setDefaults: () => Promise.resolve(),
  setConfigSettings: () => Promise.resolve(),
  fetchAndActivate: () => Promise.resolve(false),
  fetch: () => Promise.resolve(),
  activate: () => Promise.resolve(false),
  getValue: () => ({ asString: () => '', asBoolean: () => false, asNumber: () => 0, getSource: () => 'default' }),
  getAll: () => ({}),
  lastFetchTime: 0,
  lastFetchStatus: 'no-fetch-yet',
});

export default remoteConfig;
